import Store from 'store/store';

export const IMAGE_REGION_ROOT_DYNAMIC = '%IMAGE_REGION_ROOT_DYNAMIC%';

export function useDynamicAssetFolder(path) {
	if (!path || typeof path !== 'string') {
		return path;
	}
	const store = Store.get();
	const imageRegionRoot = store?.appData?.urls?.roots?.imageRegion;
	const assetUpdateDateTime = store?.appData?.options?.useAssetUpdateDateTime;
	let newRoot = imageRegionRoot;
	if (assetUpdateDateTime && (Date.now() > assetUpdateDateTime)) {
		newRoot += '/updates';
	}
	return path.replace(/%IMAGE_REGION_ROOT_DYNAMIC%/g, newRoot);
}
